// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5k-2";
export var blackBorderOnHover = "_5k-7";
export var cell = "_5k-6";
export var cellContainer = "_5k-3";
export var checked = "_5k-8";
export var disabled = "_5k-5";
export var featuredIconCellContainer = "_5k-9";
export var featuredIconTextContainer = "_5k-b";
export var featuredIconWrapper = "_5k-a";
export var noBorder = "_5k-c";
export var orangeSelectedRow = "_em-3";
export var overflowableText = "_5k-0";
export var overflowableTextContainer = "_5k-1";
export var row = "_5m-0";
export var rowCheckboxCell = "_5k-4";
export var selectableTable = "_em-2";